import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import ConfirmModal from "../Confirm";
import { deleteUser } from "../../../../store/BackOffice/actions";
import { openModal } from "../../../../store/Modals/actions";
import {
  MODAL_CONFIRM,
  MODAL_REJECT_USER,
} from "../../../../store/Modals/constants";
import { CONFIRM_REJECT_USER_MESSAGE } from "../Confirm/constants";

const RejectUSer = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(openModal(MODAL_CONFIRM));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ConfirmModal
      modal={MODAL_REJECT_USER}
      action={() => dispatch(deleteUser(true))}
      message={CONFIRM_REJECT_USER_MESSAGE}
    />
  );
};

export default RejectUSer;
